import axiosInstance from "@app/axiosInstance";
import { useCompany } from "@app/providers/CompanyContextProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import notification from "antd/lib/notification";

export const useBillingMutations = () => {
  const queryClient = useQueryClient();
  const { selectedCompany } = useCompany();
  const companyId = selectedCompany?.companyId;
  const successUrl = `${window.location.origin}/#/company/${companyId}`;

  const { mutate: checkout, isPending: isCheckoutPending } = useMutation({
    mutationFn: () =>
      axiosInstance
        .post("/stripe/checkout", {
          cancelUrl: window.location.href,
          companyId,
          successUrl,
        })
        .then((response) => response.data),
    onError: (error) => {
      console.error(error);
      notification.error({ title: "Failed to checkout" });
    },
    onSuccess: async ({ url }: { url: string }) => {
      if (!url) {
        throw new Error("Failed to create session");
      }
      window.location.href = url;
      queryClient.invalidateQueries({ queryKey: ["company", companyId] });
      notification.success({
        description: "Checkout successful",
        title: "Success",
      });
    },
  });

  const isMutationPending = isCheckoutPending;
  return { checkout, isMutationPending };
};
